<script>
import IconX from "@js/components/Icons/IconX.vue";
import IconMinus from "@js/components/Icons/IconMinus.vue";
import IconPlus from "@js/components/Icons/IconPlus.vue";
import NumberFormatComponent from "@js/components/Formatter/NumberFormatComponent.vue";
import {useCartStore} from "@js/store/CartStore.js";
import {Link, router} from "@inertiajs/vue3";
import default_img from "@img/defaults/product-not-found.webp";

export default {
    name: "CartProduct",
    methods: {
        router() {
            return router
        }
    },
    props: {
        product: {
            required: true,
            type: Object,
        }
    },
    components: {NumberFormatComponent, IconPlus, IconMinus, IconX, Link},
    watch: {
        'product.quantity': function (newVal) {
            if (newVal < 1) {
                this.cartStore.deleteProductFromCart(this.product.id)
            }
        }
    },
    mounted() {

    },
    setup() {
        const cartStore = useCartStore()

        return {cartStore, default_img}
    }
}
</script>

<template>
    <div
        class="rounded-lg border border-gray-200 bg-white p-4 sm:px-6 sm:py-4 shadow-sm hover:border-indigo-600 transition">
        <div class="space-y-4 md:flex md:items-center md:justify-between md:gap-6 md:space-y-0">
            <div class="flex items-center justify-between sm:justify-start">
                <Link :href="route('product.show',{path: product.full_path})" class="shrink-0 sm:order-1 me-6">
                    <img class="h-20 w-20 object-contain"
                         :src="product.image !== null
                            ? `/storage/products/${product.image.path}/cover/${product.image.order[0]}`
                            : `/assets/images/defaults/product-not-found.webp`"
                         :title="product.name" :alt="product.name"/>
                </Link>
                <div class="flex justify-start items-end sm:items-start flex-col md:space-y-2 sm:order-2">
                    <Link :href="route('product.show',{path: product.full_path})"
                          class="text-base font-bold text-gray-900 hover:underline">
                        {{ product.name }}
                    </Link>
                    <button type="button" @click.prevent="cartStore.deleteProductFromCart(product.id)"
                            class="inline-flex items-center text-sm font-medium text-red-600 hover:underline transition">
                        <IconX class="me-1.5 h-5 w-5 stroke-red-600"/>
                        Удалить
                    </button>
                </div>
            </div>
            <div class="flex items-center justify-between sm:order-3 md:justify-end">
                <div class="flex items-center">
                    <button type="button" @click.prevent="cartStore.removeProductFromCart(product.id)"
                            class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100">
                        <IconMinus class="h-2.5 w-2.5 text-gray-900"/>
                    </button>
                    <div v-text="product.quantity"
                         class="w-10 shrink-0 border-0 bg-transparent text-center text-sm font-medium text-gray-900 focus:outline-none focus:ring-0"/>
                    <button type="button" @click.prevent="cartStore.addProductToCart(product)"
                            class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border border-gray-300 bg-gray-100 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100">
                        <IconPlus class="h-2.5 w-2.5 text-gray-900"/>
                    </button>
                </div>
                <div class="text-end md:order-4 md:w-32">
                    <p class="text-base font-bold text-gray-900">
                        <NumberFormatComponent :number="product.price * product.quantity" append_text=" ₽"/>
                    </p>
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
